/**
 * Define the initial state for the app
 */
const initialState = {
  app: {
    vizInfo: { location: 'Loading location...' },
    clientInfo: {},
    infoReady: false,
    error: null,
  },
  map: {
    allIncidents: {},
    totalNumber: 0,
    incidentsFiltered: null,
    selectedFilters: '',
    categories: {},
    errorCategories: null,
    errorAll: null,
    errorFiltered: null,
    loading: true,
  },
  popUp: {
    incidentData: {},
    sliderData: {},
    errorPopUp: null,
  },
};

export default initialState;
